import React from 'react';

import { useTriggerEmailMessageFailMutation } from '@dashboard/generated/wp/administrator';
import { EmailMessageStatus, type FEmailMessageFragment } from '@dashboard/generated/wp/platform';
import { Button } from '@mui/material';

type Props = {
  emailMessage: FEmailMessageFragment;
};

export default function TriggerFailButton({ emailMessage }: Props) {
  const [trigger, { loading: disabled }] = useTriggerEmailMessageFailMutation();

  const status = emailMessage.status;
  switch (status) {
    case EmailMessageStatus.Deleted:
    case EmailMessageStatus.Paused:
    case EmailMessageStatus.Succeeded:
    case EmailMessageStatus.Failed:
      return null;
  }

  const onClick = () => {
    trigger({ variables: { id: emailMessage.id } });
  };
  return (
    <Button variant="contained" disabled={disabled} onClick={onClick}>
      Fail
    </Button>
  );
}
